<app-diagram [splitters]="allSplitters" [boxes]="boxes">
</app-diagram>
